import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { AddInspectorComponent } from '../add-inspector/add-inspector.component';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA, MatSelectionList } from '@angular/material';
import { SitesService } from '../../../sites.service';
import { PositionAssignmentsService } from '../../../position-assignments.service';
import { FsService } from '../../../fs.service';
import { ShiftsService } from '../../../shifts.service';
import { InspectorService } from '../../../inspector.service';
import { PositionService } from '../../../position.service';
import { Shift } from '../../../shift';
import { SelectionModel } from '@angular/cdk/collections';
import { AgencyService } from '../../../agency.service';
import { TransactionService } from '../../../transaction.service';

@Component({
  selector: 'app-add-agency',
  templateUrl: './add-agency.component.html',
  styleUrls: ['./add-agency.component.scss']
})
export class AddAgencyComponent implements OnInit {

  columns: any = ['name'];
  fss: any[] = [];
  agencies: any = [];
  agenciesOg: any = [];
  shifts: any = [];
  selectedAgency: any = [];
  siteName = '';
  siteId = '';
  positionId = '';
  item: any;
  ppeInfo = 'test';
  selectedShift: Shift = new Shift();
  agencyRequirements = '';
  @ViewChild(MatSelectionList) agencyMatList: MatSelectionList;
  startTime = '';
  endTime = '';
  currentAssignments: any[] = [];

  shouldForceUpdate: boolean;

  constructor(
    public dialogRef: MatDialogRef<AddInspectorComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fsService: FsService,
    private shiftService: ShiftsService,
    private inspectorService: InspectorService,
    private positionService: PositionService,
    private positionAssignmentService: PositionAssignmentsService,
    private sitesService: SitesService,
    public dialog: MatDialog,
    private agencyService: AgencyService,
    private transactionService: TransactionService
  ) { }

  ngOnInit() {
    this.siteName = this.data.siteName;
    this.siteId = this.data.siteId;
    this.agencies = this.agenciesOg;
    this.item = this.data.item;
    this.positionId = this.item.id;
    this.selectedShift = this.data.selectedShift;
    this.agencyMatList.selectedOptions = new SelectionModel(false);
    this.startTime = this.selectedShift.start;
    this.endTime = this.selectedShift.end;
    this.getAgencies();
    this.getShifts(this.siteName);
    this.getSupervisors(this.siteName);
    this.getAgencyRequirements(this.siteName);
    this.getAssignments(this.positionId);
  }

  getSupervisors(site: string) {
    this.fsService.getSupervisors(site)
      .subscribe((data) => {
        for ( const fs of data) {
          if (fs.shift === this.selectedShift.name) {
            this.fss.push(fs);
          }
        }
    });
  }

  getAgencies() {
    this.agencyService.getAgencyList()
      .subscribe((data) => {
        this.agenciesOg = data;
        this.applyAgencyFilter('');
    });
  }

  getShifts(site: string) {
    this.shiftService.getShifts(site)
      .subscribe((data) => {
        this.shifts = data;
      });
  }

  getAgencyRequirements(site: string) {
    this.sitesService.getAgencyRequirements(site)
      .subscribe((data) => {
        this.agencyRequirements = data[0].agencyRequirements;
        this.agencyRequirements = this.agencyRequirements.replace(/(\r\n|\n|\r)/g, '<br />');
      }
    );
  }

  getAssignments(itemId: any) {
    this.positionAssignmentService.getCurrentPositionAssignments(itemId)
      .subscribe((data) => {
        this.currentAssignments = data;
      }
    );
  }

  assignToInspectorClicked() {
    this.dialogRef.close({result: 'inspectorClicked'});
  }

  addClicked() {
    if (this.selectedAgency.length === 0) {
      alert('You must select an Inspector to allocate');
      return;
    } else if (this.startTime === '') {
      alert('You must enter a start time');
      return;
    } else if (this.endTime === '') {
      alert('You must enter an end time');
      return;
    }
    this.saveAgency();
  }

  closeClicked() {
    this.dialogRef.close();
  }

  applyAgencyFilter(filterValue: string) {
    this.agencies = this.agenciesOg;
    this.agencies = Object.assign([], this.agenciesOg).filter(
      item => item.name.toLowerCase().indexOf(filterValue.toLowerCase()) > -1
    );
  }

  assignAgency(inspector: any) {
    if (this.agencyMatList.selectedOptions.selected.length === 0) {
      this.selectedAgency = [];
    } else {
      this.selectedAgency = [inspector];
    }
  }

  saveAgency() {
    if (this.item.isRequested === 1) {
      this.positionAssignmentService.updatePositionAssignment(this.positionId, '1', '0', this.selectedAgency[0].id,
        localStorage.getItem('userFullName'))
        .subscribe((data) => {
          if (data.length === 0) {
            this.transactionService.addTransaction(localStorage.getItem('userFullName'), this.siteId, this.selectedShift.name,
            'Agency ' + this.selectedAgency[0].name + ' assigned to the ' + this.selectedShift.name + ' shift at ' + this.siteName)
              .subscribe((tdata) => {
                if (this.item.status === 0) { // if it's empty
                  this.dialogRef.close({
                    result: 'update-agency',
                    data: this.selectedAgency[0],
                    startTime: this.startTime,
                    endTime: this.endTime
                  });
                } else {
                  this.dialogRef.close({ startTime: this.startTime, endTime: this.endTime }); // trigger a refresh
                }
              }
            );
          } else {
            alert('Something went wrong');
            this.dialogRef.close({result: 'error'});
          }
        });
    } else {
      this.positionAssignmentService.addPositionAssignment(this.positionId, '1', '0', this.selectedAgency[0].id, localStorage.getItem('userFullName'))
        .subscribe(([data]: any) => { // [data] would be data[0]
          this.transactionService.addTransaction(localStorage.getItem('userFullName'), this.siteId, this.selectedShift.name,
          'Agency ' + this.selectedAgency[0].name + ' assigned to the ' + this.selectedShift.name + ' shift at ' + this.siteName)
            .subscribe((tdata) => {
              if (this.shouldForceUpdate) {
                this.dialogRef.close(); // trigger a refresh
              } else if (this.item.status === 0) { // if it's empty then it's one agency
                this.dialogRef.close({
                  result: 'confirm-agency',
                  data: this.selectedAgency[0],
                  assignmentId: data.id,
                  startTime: this.startTime,
                  endTime: this.endTime
                });
              } else if (this.item.status === 2 || this.item.status === 4) { // if it's an agency or multiple agencies adding an agency
                this.dialogRef.close({
                  result: 'confirm-multiple-agencies',
                  data: this.selectedAgency[0],
                  assignmentId: data.id,
                  startTime: this.startTime,
                  endTime: this.endTime
                });
              } else {
                this.dialogRef.close({ startTime: this.startTime, endTime: this.endTime }); // trigger a refresh
              }
            }
          );
        }
      );
    }
    this.positionService.updatePositionFilled(this.positionId, '0', this.startTime, this.endTime, localStorage.getItem('userFullName'))
      .subscribe((data) => {
        if (data.length === 0) {

        } else {
          alert('Something went wrong');
          this.dialogRef.close({result: 'error'});
        }
      }
    );
  }

  removeAgencyClicked(item: any) {
    this.shouldForceUpdate = true;

    if (item.agencyId !== 0) {
      this.positionAssignmentService.removePositionAssignment(item.id)
        .subscribe((data) => {
          this.getAssignments(this.positionId);
          this.transactionService.addTransaction(localStorage.getItem('userFullName'), this.siteId, this.selectedShift.name,
            'Agency ' + item.name + ' removed from the ' + this.selectedShift.name + ' shift at ' + this.siteName)
            .subscribe((tdata) => {
            }
          );
        }
      );
    } else {
      let isLast = 1;
      for (const assign of this.currentAssignments) {
        if (assign.isRequested !== 1 && assign.inspectorId !== 0 && assign.id !== item.id) {
          isLast = 0;
          break;
        }
      }

      this.positionAssignmentService.removePositionAssignmentLast(item.id, item.posId, isLast)
        .subscribe((data) => {
          this.getAssignments(this.positionId);
          this.transactionService.addTransaction(localStorage.getItem('userFullName'), this.siteId, this.selectedShift.name,
            'Agency ' + item.name + ' removed from the ' + this.selectedShift.name + ' shift at ' + this.siteName)
            .subscribe((tdata) => {
            }
          );
        }
      );
    }
  }

}
